/* tslint:disable */

/**
 */
export class deCryptoForm {
    data?: string;
    key?: string;
}
